import AntdBreadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";

export const DocterBreadcrumbs = ({ last }) => {
  const breadcrumbsList = [
    { text: "Master", link: "/master-primary-specialisation" },
    { text: "Doctors", link: "/master-primary-specialisation" },
    { text: last, link: "" },
  ];

  return (
    <AntdBreadcrumbs
      className="healthsyMasterBreadCrumbs"
      breadcrumbsList={breadcrumbsList}
    />
  );
};

export const ThreeLayerBreadcrumbs = ({ last }) => {
  const breadcrumbsList = [
    { text: "Master", link: "/master-primary-specialisation" },
    { text: last, link: "" },
  ];

  return (
    <AntdBreadcrumbs
      className="healthsyMasterBreadCrumbs"
      breadcrumbsList={breadcrumbsList}
    />
  );
};

export const statuses = ["Active", "Inactive"];

export const DocternavBarData = [
  {
    name: "Primary Specialisation",
    navigatePath: "/master-primary-specialisation",
  },
  { name: "In-Clinic Fee", navigatePath: "/master-inclinic-fee" },
  { name: "UG Degree", navigatePath: "/master-ug-course" },
  { name: "PG Degree", navigatePath: "/master-pg-degree" },
];

export const PartneredPharmaciesnavBarData = [
  {
    name: "Pharmacy Business Type",
    navigatePath: "/master-partnered-pharmacy",
  },
  { name: "Inventory Value", navigatePath: "/master-inventory" },
  { name: "Pharmacy Store Size", navigatePath: "/master-pharmacy-store" },
];

export const PartneredPharmaciesBreadcrumbs = ({ last }) => {
  const breadcrumbsList = [
    { text: "Master", link: "/master-primary-specialisation" },
    { text: "Partnered Pharmacies", link: "/master-partnered-pharmacy" },
    { text: last, link: "" },
  ];

  return (
    <AntdBreadcrumbs
      className="healthsyMasterBreadCrumbs"
      breadcrumbsList={breadcrumbsList}
    />
  );
};

export const CommonTabnavBarData = [
  {
    name: "Gender",
    navigatePath: "/master-gender",
  },
  {
    name: "Experience",
    navigatePath: "/master-experience",
  },
  {
    name: "Languages Known",
    navigatePath: "/master-languages",
  },
  {
    name: "Location(City / Town)",
    navigatePath: "/master-location",
  },
  {
    name: "Timings",
    navigatePath: "/master-timing",
  },
  {
    name: "Days",
    navigatePath: "/master-days",
  },
  {
    name: "BD",
    navigatePath: "/master-bd",
  },
  {
    name: "Lead Status",
    navigatePath: "/master-lead-status",
  },
];

export const CommonTabBreadcrumbs = ({ last }) => {
  const breadcrumbsList = [
    { text: "Masters", link: "/master-primary-specialisation" },
    { text: "Common", link: "/master-gender" },
    { text: last, link: "" },
  ];
  return (
    <AntdBreadcrumbs
      className="healthsyMasterBreadCrumbs"
      breadcrumbsList={breadcrumbsList}
    />
  );
};
